import { ToastIntent } from "@fluentui/react-components";
import { createContext, useContext } from "react";

type ToastContextType = {
  showToast: (message: string, intent?: ToastIntent) => void;
};

export const ToastContext = createContext<ToastContextType | null>(null);

export const useToast = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error("useToast must be used within ToastProvider");
  }
  return ctx;
};
